var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7355 18.0284C17.3838 18.3785 16.8147 18.3785 16.4626 18.0284L8.99989 10.5986L1.53552 18.0284C1.18378 18.3785 0.614703 18.3785 0.262578 18.0284C-0.0891535 17.6783 -0.0891535 17.1119 0.262578 16.7614L7.72864 9.33322L0.263703 1.9034C-0.0880285 1.5533 -0.0880285 0.986851 0.263703 0.636356C0.615434 0.286254 1.18452 0.286254 1.53664 0.636356L8.99989 8.06785L16.4643 0.638036C16.816 0.287933 17.3851 0.287933 17.7372 0.638036C18.0889 0.988139 18.0889 1.55459 17.7372 1.90508L10.2711 9.33322L17.7355 16.763C18.0899 17.1102 18.0899 17.6813 17.7355 18.0284Z",
    fill: "#71717A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.0a813fe23ab3190a0e6d4dc7d84e4455.svg";
export { ForwardRef as ReactComponent };